// RoomTab.tsx
import React, { useState } from "react";
import { Flex, Button, Group, Box, Divider, Transition, rem } from "@mantine/core";
import { FaFileExcel } from "react-icons/fa";
import { AirflowExcelImportSmart } from "../components/AirflowExcelImportSimple";
import { RoomsTable } from "./RoomsTable/RoomTable";
import { useAppSelector } from "../app/hooks";
import { RoomSideBar } from "../RoomSideBar/RoomSideBar";
import PnsTreePanelContainer from "../DesignTab/routing/PnsTreePanelContainer";
import { useAppUrlStateSync } from "../hooks/useAppUrlStateSync";

const SIDEBAR_WIDTH = 600;
const PNS_PANEL_WIDTH = 360;

export const RoomTab: React.FC = () => {
  useAppUrlStateSync({ module: false, floor: false, rotation: false });

  const [excelImportOpen, setExcelImportOpen] = useState(false);

  const copySpaceModeActive = useAppSelector((s) => s.design.copySpaceModeActive);

  const selectedSpaceNumber = useAppSelector((s) => s.design.selectedSpaceNumber);
  const isOpen = !!selectedSpaceNumber && !copySpaceModeActive;

  return (
    <Flex direction="column" h="100%" w="100%" p="md" gap="sm">
      {/* Knappraden */}
      <Group justify="flex-start" wrap="nowrap">
        <Button
          size="xs"
          leftSection={<FaFileExcel size={14} />}
          onClick={() => setExcelImportOpen(true)}
          radius="sm"
        >
          Excelimport (tilluft/avtrekk)
        </Button>
      </Group>

      {/* Modaler */}
      <AirflowExcelImportSmart opened={excelImportOpen} onClose={() => setExcelImportOpen(false)} />

      <Divider my={rem(8)} />

      {/* Huvudinnehåll – flex som fyller resten */}
      <Flex flex={1} style={{ position: "relative", overflow: "hidden" }}>
        {/* Längst till vänster: PNS-panel */}
        <Box
          w={PNS_PANEL_WIDTH}
          h="100%"
          style={{
            flexShrink: 0,
            minWidth: 0,
          }}
        >
          <PnsTreePanelContainer />
        </Box>

        {/* Vänster: tabellen */}
        <Box style={{ flex: 1, minWidth: 0, overflow: "auto" }}>
          <RoomsTable />
        </Box>

        {/* Höger: sidebar */}
        <Transition mounted={isOpen} transition="slide-left" duration={400} timingFunction="ease">
          {(styles) => (
            <Box
              w={SIDEBAR_WIDTH}
              h="100%"
              style={{
                ...styles,
                borderLeft: "100%",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                background: "white",
                overflowY: "auto",
                flexShrink: 0,
              }}
            >
              <RoomSideBar />
            </Box>
          )}
        </Transition>
      </Flex>
    </Flex>
  );
};
